module.exports = __webpack_public_path__ + "static/logoVascepaEPA-72e29364aa144180ece0dabf70fd471d.svg";